module.exports = __webpack_public_path__ + "static/media/saprate_room_for_girl.dfc5d61d.jpg";